export default {
  functional: true,

  render(h, { props, children }) {
    const classNames = {
      'page-content': true,
      // 上の要素にくっつく（余白なし）バージョン
      'is-top-sticked': props.topSticked === true,
      // 下の要素にくっつく（余白なし）バージョン
      'is-bottom-sticked': props.bottomSticked === true,
      // ローディング表示
      'is-loading': props.loading === true,
    }

    return h('div', { class: classNames }, children)
  }
}
